import createActionType from "../../utils/createActionType";

export const MODULE = "planner/status-filter";

export const SET_IS_FETCHING_STATUSES = createActionType(MODULE, "setIsFetchingStatuses");

export const SET_STATUSES = createActionType(MODULE, "setStatuses");

export const SET_SELECTED_STATUSES = createActionType(MODULE, "setSelectedStatuses");

export const RESET = createActionType(MODULE, "reset");
